import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FaHome, FaInfoCircle, FaBuilding, FaUsers, FaEnvelope, FaUserShield, FaArrowRight } from 'react-icons/fa';
import { useAuth } from '../../contexts/AuthContext';
import { PageHeader } from './styles/AdminStyles';

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 1.25rem;
`;

const Card = styled(Link)`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.border};
  padding: 1.75rem 1.5rem;
  position: relative;
  transition: ${({ theme }) => theme.transitions.base};
  display: flex;
  flex-direction: column;
  gap: 0.75rem;

  &::before {
    content: '';
    position: absolute;
    top: 0; left: 0;
    width: 100%;
    height: 3px;
    background: ${({ theme }) => theme.colors.gold};
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 0.35s ease;
  }

  &:hover {
    box-shadow: ${({ theme }) => theme.shadows.cardHover};
    transform: translateY(-3px);
    &::before { transform: scaleX(1); }
  }

  .icon {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.goldSoft};
    color: ${({ theme }) => theme.colors.goldDark};
    display: flex;
    align-items: center;
    justify-content: center;
  }

  h3 {
    font-family: ${({ theme }) => theme.fonts.heading};
    font-size: 1.15rem;
    color: ${({ theme }) => theme.colors.nearBlack};
  }

  p {
    font-size: 0.88rem;
    color: ${({ theme }) => theme.colors.textMuted};
    margin-bottom: 0.5rem;
    flex: 1;
  }

  .go {
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.goldDark};
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
  }
`;

const Dashboard = () => {
  const { user } = useAuth();

  const cards = [
    { to: '/admin/home', icon: <FaHome />, title: 'Home Page', desc: 'Edit hero, banner, intro and preview content.' },
    { to: '/admin/about', icon: <FaInfoCircle />, title: 'About Page', desc: 'Manage page sections, items and images.' },
    { to: '/admin/companies', icon: <FaBuilding />, title: 'Companies', desc: 'Add, edit and publish group companies.' },
    { to: '/admin/team', icon: <FaUsers />, title: 'Team', desc: 'Manage team members and their bios.' },
    { to: '/admin/contact', icon: <FaEnvelope />, title: 'Contact', desc: 'Update contact info and review messages.' },
  ];
  if (user?.role === 'superAdmin') {
    cards.push({ to: '/admin/users', icon: <FaUserShield />, title: 'Users', desc: 'Manage admin users and permissions.' });
  }

  return (
    <>
      <PageHeader>
        <div className="eyebrow">Welcome, {user?.username}</div>
        <h1>Dashboard</h1>
        <p>Choose a section below to manage your website content.</p>
      </PageHeader>
      <Grid>
        {cards.map(c => (
          <Card key={c.to} to={c.to}>
            <div className="icon">{c.icon}</div>
            <h3>{c.title}</h3>
            <p>{c.desc}</p>
            <span className="go">Manage <FaArrowRight /></span>
          </Card>
        ))}
      </Grid>
    </>
  );
};

export default Dashboard;
